export const Footer = () => {
  return (
    <div className={"footer"}>
      <div className={"container"}>
        <ul>
          <li>Beralink 2025</li>
          <li>
            <a href="https://x.com/Bera_link" target="_blank">
              <img src="/images/twitter.png" alt="Twitter" />
            </a>
          </li>
          <li>
            <a href="https://discord.gg/beralink" target="_blank">
              <img src="/images/discord.png" alt="Discord" />
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};
